var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBuildingsGroup = function SvgBuildingsGroup(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 11,
    "data-width-16": 13,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-72": 52,
    viewBox: "0 0 14.6 14.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.933 3.1h3.889c.611 0 1.111.696 1.111 1.548v7.738c0 .85-.5 1.547-1.111 1.547H8.933zM1.882.6h5.77c.705 0 1.281.667 1.281 1.481v11.852h-7.05c-.706 0-1.283-.666-1.283-1.481V2.082C.6 1.266 1.177.6 1.882.6M3.1 7.267h3.333M10.664 7.267h1.539M10.664 10.344h1.539M3.1 4.19h3.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.433 10.245H3.1v3.688h3.333z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBuildingsGroup);
export default ForwardRef;